import axios from "axios";
import { environment } from "src/environments/environment";
import { findWhere, find } from 'underscore'
import MagicPortal from 'magic-portal';
import * as mime from 'mime-types';
import { Capacitor } from "@capacitor/core";

export class MiscHelper {
    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static async getAssetUrl(path: string) {
        let url = `${environment.assets_url}${path}`;
        if (environment.is_online) {
            let params = this.getCookieValue('storage_token');
            let extension = params.replace(/"/g, "");
            url = `${url}?${extension}`;
        }
        return url;
    }

    static async getLocalFile(path: string) {
        const worker = new Worker("assets/workers/git.js");
        const portal = new MagicPortal(worker);
        portal.set("mainThread", {}, {
            void: ["getFile"]
        });
        const workerThread = await portal.get("workerThread");
        try {
            const file = await workerThread.getFile(`/${environment.local_db_name}/${path}`);
            let mime_type = mime.lookup(path);

            //  fallback for .db files
            if (!mime_type) {
                const filename = path.replace(/^.*[\\\/]/, '');
                const extension = /(?:\.([^.]+))?$/.exec(filename)[1];
                if (extension === 'db') {
                    mime_type = 'application/x-sqlite3'
                }
            }

            if (mime_type) {
                return new Blob([file], { type: mime_type });
            } else {
                throw new Error(`Can't identify file type`);
            }
        } catch (e) {
            console.log('got error', e);
        }
    }

    static async getJson(path: string): Promise<any> {
        try {
            let url = `${environment.assets_url}${path}`;
            if (environment.is_online) {
                let params = this.getCookieValue('storage_token');
                let extension = params.replace(/"/g, "");
                url = `${url}?${extension}`;
            }
            let result = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return result.data;
        } catch (e) {
            console.log(`MiscHelper.getJson failed`, e);
            return null;
        }
    }

    static getCookieValue(name) {
        const cookiestring = RegExp(name + "=[^;]+").exec(document.cookie);
        return cookiestring.toString().replace(/^[^=]+./, "");
    }

    static getFileTypeFromMime(content_type: string) {
        const mappings = [
            {
                name: 'image',
                types: ['image/gif', 'image/jpeg', 'image/png', 'image/bmp']
            },
            {
                name: 'video',
                types: ['video/mpeg', 'video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-sgi-movie', 'application/mp4']
            }
        ];

        const type = find(mappings, item => {
            return item.types.indexOf(content_type) > -1
        });
        if (type) {
            return type.name;
        }
    }

    static async blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
}